import { Button, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { mentoriaToken, servicioRegistro } from './utils/servicioRegistro';

export interface IBannerRegisterDataProps {
  title: string;
  description?: React.ReactNode;
  imagen: string;
  ctaTitle: string;
  ctaEvent: string;
}

export const BannerRegisterData = ({title, description, imagen, ctaTitle, ctaEvent}: IBannerRegisterDataProps): JSX.Element => {
    const Context = useContext(GlobalContext);
    const [userToken, setUserToken] = useState<string | null>(null);
    const [isAppLoaded, setIsAppLoaded] = useState(false);
    const [dataRegister, setDataRegister] = useState({});
    const [login, setLogin] = useState<boolean>(false);

    useEffect(() => {
        if(Context.gigyaContext.gigyaAccount !== undefined || sessionStorage.getItem('cfmUserUID') !== null){
            setLogin(true);
        }
    },[Context.gigyaContext.gigyaAccount]);

    const fetchToken = async (infoUser:string) => {
        const response = await mentoriaToken(infoUser);
        setUserToken(response);
    }
    useEffect(() => {
        if(isAppLoaded){
            const timer = setTimeout(() => {
                if (Context.gigyaContext.gigyaAccount !== undefined) {
                    fetchToken(Context.gigyaContext.gigyaAccount?.UID);
                    setDataRegister({
                        'name': Context.gigyaContext.gigyaAccount?.profile?.firstName ?? 'Nombre no registrado',
                        'documentType': Context.gigyaContext.gigyaAccount?.data?.docType ?? 'Tipo de documento no registrado',
                        'document': Context.gigyaContext.gigyaAccount?.data?.docNumber ?? 'Número de documento no registrado',
                        'cellPhone': Context.gigyaContext.gigyaAccount?.data?.mobile ?? 'Número de celular no registrado',
                        'email': Context.gigyaContext.gigyaAccount?.profile?.email ?? 'Correo no registrado',
                        'affiliateStatus': Context.gigyaContext.gigyaAccount?.data?.state ?? 'Estado de afiliación no registrado',
                    });
                }else{
                    Context.gigyaContext.login();
                }
            }, 5000);
            return () => clearTimeout(timer);
        }

    }, [isAppLoaded]);

    useEffect(()=>{
        if(!login) return;
        setLogin(true);
    },[]);

    useEffect(() => {
        const loadApp = async () => {
            await new Promise(resolve => setTimeout(resolve, 3000));
            setIsAppLoaded(true);
        };
        loadApp();
    }, [isAppLoaded]);

    const handleRegister = async () => {
        if (Context.gigyaContext.gigyaAccount?.UID !== undefined) {
            try {
                await fetchToken(Context.gigyaContext.gigyaAccount?.UID);
                if (userToken) {
                    try {
                        await servicioRegistro(JSON.stringify(dataRegister), userToken);
                        window.open(ctaEvent, '_blank' , 'noopener,noreferrer');
                    } catch (error) {
                        console.error('Failed to register user');
                    }
                }
            } catch (error) {
                console.error('Failed to register user');
            }
        }
    };

    const handleModalLogin = () => {
        Context.gigyaContext.login();
    }


  return (
    <Grid container
        style={{ 
            backgroundImage: `url(${imagen})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
            minHeight: '20vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backgroundBlendMode: 'darken',
        }}
    >
        <Grid item
            style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '4rem'
            }}
        >
            <Typography variant="h2" component="strong" style={{color:'#ffffff', textAlign:'center'}} >{title}</Typography>
            <Typography variant="body1" component="p"  
                style={{ 
                    marginTop: '2rem',
                    textAlign: 'center',
                    maxWidth: '70vw',
                    color: '#ffffff'
                }}
            >
                {description}
            </Typography>
            {login ? 
            <Button variant="contained"
                style={{ 
                    marginTop: '2rem',
                    backgroundColor: '#EE2B7B',
                    borderRadius: '2rem',
                    textTransform: 'none',
                    color: '#ffffff',
                }}
                onClick={() => handleRegister()}
                >
                {ctaTitle}
            </Button>
            :
            <Button variant='contained'
                style={{
                    marginTop: '2rem',
                    backgroundColor: '#EE2B7B',
                    borderRadius: '2rem',
                    textTransform: 'none',
                    color: '#ffffff',
                    }}
                    onClick={() => handleModalLogin()}
                    >
                {ctaTitle}
            </Button>
            }
        </Grid>

    </Grid>
  )
}